import React, { useState, useRef } from 'react';
import { arrayOf, bool, func, node, number, object, oneOfType, shape, string, } from 'prop-types';
import Select, { components } from 'react-select';
import { Flex } from '../layout';
import setClass from '../../common/set-class';
import useOutsideClick from '../../hooks/use-outside-click';
import Icon from '../icon';
const DropdownIndicator = (props) => {
    const { selectProps: { inputValue, clearSearchValue }, } = props;
    const isSearching = typeof inputValue !== 'string' || inputValue !== '';
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(components.DropdownIndicator, { ...props }, isSearching ? (React.createElement("button", { type: "button", onClick: clearSearchValue },
        React.createElement(Icon, { name: "circle-xmark", className: "b-select__icon b-select__icon--search" }))) : (React.createElement(Icon, { name: "magnifying-glass", className: "b-select-search b-select__icon b-select__icon--search" }))));
};
const Option = (props) => React.createElement(components.Option, { ...props });
const Menu = (props) => {
    const { children } = props;
    return React.createElement("div", { className: "b-select-multi__menu" }, children);
};
const MenuList = (props) => {
    const { children } = props;
    return (React.createElement("div", { className: "select-multi-search__menu-list" },
        React.createElement(components.MenuList, { ...props }, children)));
};
const Blanket = (props) => {
    const { onClick } = props;
    return React.createElement("div", { tabIndex: 0, onClick: onClick });
};
const ValueContainer = (props) => {
    const { disabled, isOpen, placeholder, toggleOpen, value } = props;
    const renderValues = () => {
        if (!value) {
            return (React.createElement("p", { className: "b-select-multi-search__inactive-msg" }, placeholder));
        }
        return (React.createElement("span", { className: setClass([
                'b-txt',
                'b-select-search__value',
                disabled ? 'b-select-search__value--disabled' : '',
            ]) }, value.label));
    };
    return (React.createElement("div", { tabIndex: 0, className: "b-select-multi__value-container-toggle", onClick: toggleOpen },
        React.createElement(Flex, { justify: "flex-start", align: "center", className: setClass([
                'b-select-multi__value-container',
                disabled ? 'b-select-multi__value-container--disabled' : '',
                isOpen ? 'b-select-multi__value-container--active' : '',
            ]), wrap: true },
            renderValues(),
            React.createElement(Icon, { name: "angle-down", className: setClass([
                    'b-select__icon',
                    isOpen ? '' : 'b-select__icon--closed',
                ]) }))));
};
const Dropdown = (props) => {
    const { children, disabled, isOpen, onDropdownClose, placeholder, toggleOpen, value, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(ValueContainer, { disabled: disabled, isOpen: isOpen, placeholder: placeholder, toggleOpen: toggleOpen, value: value }),
        isOpen && !disabled ? React.createElement(Menu, null, children) : null,
        isOpen && !disabled ? React.createElement(Blanket, { onClick: onDropdownClose }) : null));
};
const MultiSelectSearch = (props) => {
    const { className, compact, auto, disabled, extra, isInitialOpen, onChange, onClose, options, placeholder, searchPlaceholder, style, testId, value, errorText, } = props;
    const [isOpen, setIsOpen] = useState(isInitialOpen);
    const [inputValue, setInputValue] = useState('');
    const wrapperRef = useRef(null);
    const hasError = typeof errorText === 'string' && errorText !== '';
    // eslint-disable-next-line consistent-return
    const handleOnClose = async (isSelectOpen) => {
        if (isSelectOpen) {
            await new Promise((resolve) => {
                setInputValue('');
                onClose();
                // @ts-expect-error ts-migrate(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
                resolve();
            });
            return setIsOpen(false);
        }
    };
    useOutsideClick(wrapperRef, (e) => {
        if (!e.composedPath().includes(wrapperRef?.current)) {
            handleOnClose(isOpen);
        }
    }, 
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
    [isOpen]);
    const toggleOpen = () => {
        if (!disabled) {
            handleOnClose(isOpen);
            setIsOpen((prevToggleVal) => !prevToggleVal);
        }
    };
    const onSelectChange = (selectedValues, actionObj) => {
        onChange(selectedValues, actionObj);
        handleOnClose(isOpen);
    };
    return (React.createElement("div", { className: setClass([
            'b-select-multi__wrapper',
            className,
            compact && 'b-select--max-width',
            auto && '--auto',
            hasError && 'b-select-search--error',
        ]), ref: wrapperRef, "data-testid": testId },
        React.createElement(Dropdown, { disabled: disabled, isOpen: isOpen, onDropdownClose: toggleOpen, placeholder: placeholder, toggleOpen: toggleOpen, value: value },
            React.createElement(Select, { className: "b-select-multi-menu", classNamePrefix: "b-select", components: {
                    DropdownIndicator,
                    MenuList,
                    Option,
                    ClearIndicator: null,
                }, clearSearchValue: () => setInputValue(''), inputValue: inputValue, options: options, placeholder: searchPlaceholder, onChange: onSelectChange, onInputChange: (v, { action }) => {
                    if (action === 'input-change') {
                        setInputValue(v);
                    }
                }, value: value, noOptionsMessage: () => (React.createElement("p", { className: "b-select-multi-search__no-results-msg b-mb1" }, "No results found")), styles: style, isDisabled: disabled, controlShouldRenderValue: false, hideSelectedOptions: false, backspaceRemovesValue: false, menuIsOpen: true, autoFocus: true, ...extra })),
        hasError ? (React.createElement("p", { className: "b-select__err-msg" },
            React.createElement(Icon, { name: "triangle-exclamation", className: "b-select__err-icon" }),
            errorText)) : null));
};
DropdownIndicator.propTypes = {
    selectProps: shape({
        inputValue: string,
        clearSearchValue: func,
    }),
};
DropdownIndicator.defaultProps = {
    selectProps: {
        inputValue: '',
        clearSearchValue: () => { },
    },
};
MenuList.propTypes = {
    children: node,
};
MenuList.defaultProps = {
    children: React.createElement(React.Fragment, null),
};
Menu.propTypes = {
    children: node,
};
Menu.defaultProps = {
    children: React.createElement(React.Fragment, null),
};
Blanket.propTypes = {
    onClick: func,
};
Blanket.defaultProps = {
    onClick: () => { },
};
ValueContainer.propTypes = {
    disabled: bool,
    isOpen: bool,
    placeholder: string,
    toggleOpen: func,
    value: shape({ label: string, value: oneOfType([string, number]) }),
};
ValueContainer.defaultProps = {
    disabled: false,
    isOpen: false,
    placeholder: 'Select Option',
    toggleOpen: () => { },
    value: null,
};
Dropdown.propTypes = {
    children: node,
    disabled: bool,
    isOpen: bool,
    onDropdownClose: func,
    placeholder: string,
    toggleOpen: func,
    value: shape({ label: string, value: oneOfType([string, number]) }),
};
Dropdown.defaultProps = {
    children: React.createElement(React.Fragment, null),
    disabled: false,
    isOpen: false,
    onDropdownClose: () => { },
    placeholder: 'Select Option',
    toggleOpen: () => { },
    value: null,
};
MultiSelectSearch.propTypes = {
    className: string,
    compact: bool,
    auto: bool,
    disabled: bool,
    extra: object,
    isInitialOpen: bool,
    onChange: func,
    onClose: func,
    options: arrayOf(shape({ label: string, value: oneOfType([string, number]) })),
    placeholder: string,
    searchPlaceholder: string,
    style: object,
    testId: string,
    value: shape({ label: string, value: oneOfType([string, number]) }),
    errorText: string,
};
MultiSelectSearch.defaultProps = {
    className: null,
    compact: false,
    auto: false,
    disabled: false,
    extra: {},
    isInitialOpen: false,
    onChange: () => { },
    onClose: () => { },
    options: [],
    placeholder: 'Select Option',
    searchPlaceholder: 'Search Option',
    style: {},
    testId: undefined,
    value: null,
    errorText: '',
};
export default MultiSelectSearch;
